import { Outlet } from "react-router-dom";

const Accesorios = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Accesorios;
